import { render, staticRenderFns } from "./ReviewSkillChild.vue?vue&type=template&id=9ede436a&scoped=true"
import script from "./ReviewSkillChild.vue?vue&type=script&lang=js"
export * from "./ReviewSkillChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ede436a",
  null
  
)

export default component.exports